import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ValidationMessagesService } from './index.service';

@Injectable({
  providedIn: 'root',
})
export class HttpFileService {
  constructor(
    private httpClient: HttpClient,
    public validationService: ValidationMessagesService,
    private router: Router
  ) {}

  post(url: string, payload: any, options: any): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.apiUrl}${url}`,
      payload,
      options
    );
  }
}
